export default __webpack_public_path__ + "static/media/arrow-left.c63fbc4e.svg";